import React, { useEffect, useState } from 'react';
import { FiPackage, FiTruck, FiAlertTriangle, FiCheck } from 'react-icons/fi';
import styles from './OrderViewModalRedesigned.module.css';
import Moment from 'moment';
import myAxios from '../AxiosUrl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { orderDeliveryAmount } from '../Helper/deliveryAmount';

function OrderViewModalRedesigned({ setOpenModal, modalData, setRefresh, handleUpdate }) {
    const [startDate, setStartDate] = useState(new Date());
    const [status, setStatus] = useState(Number(modalData.orderStatus));
    const [location, setLocation] = useState(modalData.deliveryCharge);
    const [ReturnAmount, setReturnAmount] = useState(modalData.ReturnAmount);
    const uid = localStorage.getItem('id');
    const [Dhaka, setDhaka] = useState();
    const [Outside, setOutside] = useState();
    const [CourierReturn, setCourierReturn] = useState(
        modalData.CourierReturn ? modalData.CourierReturn : 'no'
    );
    const [loading, setLoading] = useState(false);
    const [DuplicateOrder, setDuplicateOrder] = useState([]);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [message, setMessage] = useState('');
    const [sendingMessage, setSendingMessage] = useState(false);

    // Calculate SMS credits needed (160 characters per credit)
    const calculateSMSCredits = (text) => {
        const fullMessage = `Hi, ${modalData.cName} ${text}`;
        const messageLength = fullMessage.length;
        return Math.ceil(messageLength / 160);
    };

    const smsCreditsNeeded = calculateSMSCredits(message);
    const messageLength = `Hi, ${modalData.cName} ${message}`.length;

    console.log("modalData", modalData)
    // Extract delivery information from FraudPathao data.
    // Pathao API v2 (current) drops the `customer` sub-object and exposes
    // only `customer_rating`. Older v1 responses still have `customer`
    // with delivery counts — handle both shapes.
    const getDeliveryInfo = () => {
        const fraudData = modalData.FraudPathao?.data;
        const customer_rating = fraudData?.customer_rating || null;
        const successful_delivery = fraudData?.customer?.successful_delivery ?? null;
        const total_delivery = fraudData?.customer?.total_delivery ?? null;
        const success_rate =
            total_delivery > 0
                ? Math.round((successful_delivery / total_delivery) * 100)
                : null;

        return {
            is_new: !customer_rating && !total_delivery,
            success_rate,
            successful_delivery,
            total_delivery,
            customer_rating,
            show_count: fraudData?.show_count ?? false,
        };
    };

    // Extract SteadFast fraud check data. The scraper persists the raw
    // response, which may be: (a) success with totals/frauds, (b) an
    // error envelope { error, limit, current } when rate-limited, or
    // (c) { error, status } when the merchant account is inactive.
    const getSteadFastInfo = () => {
        const sf = modalData.SteadFast;
        if (!sf) {
            return {
                has_data: false, error: null,
                total_delivered: 0, total_cancelled: 0, total_orders: 0,
                frauds: [], fraud_count: 0, success_rate: null, checkedAt: null,
            };
        }
        if (sf.error) {
            return {
                has_data: false, error: sf.error,
                total_delivered: 0, total_cancelled: 0, total_orders: 0,
                frauds: [], fraud_count: 0, success_rate: null,
                checkedAt: sf.checkedAt,
            };
        }
        const total_delivered = sf.total_delivered || 0;
        const total_cancelled = sf.total_cancelled || 0;
        const frauds = sf.frauds || [];
        const total_orders = total_delivered + total_cancelled;
        const success_rate =
            total_orders > 0 ? Math.round((total_delivered / total_orders) * 100) : null;
        return {
            has_data: true, error: null,
            total_delivered, total_cancelled, total_orders,
            frauds, fraud_count: frauds.length, success_rate,
            checkedAt: sf.checkedAt,
        };
    };

    const deliveryInfo = getDeliveryInfo();
    const steadfastInfo = getSteadFastInfo();

    useEffect(() => {
        myAxios
            .get(`get-domain-new/${uid}`)
            .then((res) => {
                if (res.data) {
                    setDhaka(parseInt(res.data.Dhaka || 0));
                    setOutside(parseInt(res.data.Outside || 0));
                }
            })
            .catch((err) => console.error('Error fetching domain:', err));
    }, []);

    useEffect(() => {
        myAxios
            .get(`/get-duplicate/${modalData.cMobile}`)
            .then((res) => {
                const now = new Date();
                const hoursAgo72 = new Date(now.getTime() - 72 * 60 * 60 * 1000);
                const DuplicateOrder = res.data.filter((order) => {
                    const orderDate = new Date(order.date);
                    return orderDate >= hoursAgo72 && order._id !== modalData._id;
                });
                setDuplicateOrder(DuplicateOrder);
            })
            .catch((err) => console.error('Error fetching duplicates:', err));
    }, [modalData._id]);

    let futureDate = null;
    if (status === 9) {
        futureDate = startDate;
    }

    const submitH = async () => {
        if (!status || !location) {
            toast.error('Status, Location, Product Required.');
            return;
        }
        setLoading(true);
        const url = `edit-order-status/${modalData._id}`;
        const formData = {
            status,
            location,
            startDate: futureDate,
            ReturnAmount,
            CourierReturn,
        };
        try {
            const res = await myAxios.post(url, formData);
            toast.success(res.data.message);
            setOpenModal(false);
            setRefresh(true);
            handleUpdate();
        } catch (error) {
            console.log(error.response.data);
        } finally {
            setLoading(false);
        }
    };

    const WithDeliveryCharge = orderDeliveryAmount(modalData, Dhaka, Outside, Outside);

    const getStatusBadge = (statusNum) => {
        const statusMap = {
            1: { label: 'New', color: 'yellow' },
            2: { label: 'Call Done', color: 'blue' },
            3: { label: 'Courier Done', color: 'green' },
            4: { label: 'Print Done', color: 'green' },
            5: { label: 'Cancel', color: 'red' },
            6: { label: 'Return', color: 'red' },
            7: { label: 'Call Not-Received', color: 'blue' },
            8: { label: 'Ask-Advance', color: 'yellow' },
            9: { label: 'Ship-Later', color: 'yellow' },
            10: { label: 'Waiting', color: 'yellow' },
            11: { label: 'Overseas', color: 'purple' },
            12: { label: 'Delivery-Issue', color: 'purple' },
            13: { label: 'Payment-Received', color: 'green' },
        };

        const statusData = statusMap[statusNum] || { label: 'Unknown', color: 'gray' };
        return (
            <span className={`${styles.statusBadge} ${styles[`status${statusData.color}`]}`}>
                {statusData.label}
            </span>
        );
    };

    const getRiskLevel = () => {
        let riskScore = 0;
        let factors = [];

        // Check Pathao data
        if (!deliveryInfo.is_new && deliveryInfo.success_rate !== null) {
            if (deliveryInfo.success_rate < 40) riskScore += 30;
            else if (deliveryInfo.success_rate < 60) riskScore += 15;
        }

        // Check SteadFast data
        if (steadfastInfo.has_data && steadfastInfo.success_rate !== null) {
            if (steadfastInfo.success_rate < 40) riskScore += 30;
            else if (steadfastInfo.success_rate < 60) riskScore += 15;
        }

        // Check fraud records
        if (steadfastInfo.fraud_count > 0) {
            riskScore += 25;
            factors.push(`${steadfastInfo.fraud_count} fraud(s)`);
        }

        // Check duplicate orders
        if (DuplicateOrder.length > 2) {
            riskScore += 20;
            factors.push(`${DuplicateOrder.length} duplicates`);
        }

        let level = 'Low';
        let color = 'green';
        if (riskScore >= 50) {
            level = 'High';
            color = 'red';
        } else if (riskScore >= 25) {
            level = 'Medium';
            color = 'yellow';
        }

        return { level, color, score: riskScore, factors };
    };

    const riskData = getRiskLevel();

    const handleSendMessage = async () => {
        if (!message.trim()) {
            toast.error('Please enter a message');
            return;
        }

        setSendingMessage(true);
        try {
            const res = await myAxios.post(`send-message/${uid}`, {
                name: modalData.cName,
                phone: modalData.cMobile,
                message: message,
                orderId: modalData._id
            });

            if (res.data.success) {
                const successMessage = res.data.remainingBalance !== undefined
                    ? `${res.data.message || 'Message sent successfully!'} | Remaining SMS: ${res.data.remainingBalance}`
                    : res.data.message || 'Message sent successfully!';
                toast.success(successMessage);
                setMessage('');
                setShowMessageBox(false);
            } else {
                toast.error(res.data.message || 'Failed to send message');
            }
        } catch (error) {
            console.error('Send message error:', error);
            toast.error(error.response?.data?.message || 'Failed to send message');
        } finally {
            setSendingMessage(false);
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={() => setOpenModal(false)}>
            <ToastContainer />
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                {/* Modal Header */}
                <div className={styles.modalHeader}>
                    <div className={styles.headerLeft}>
                        <div className={styles.headerIcon}>
                            <i className="fas fa-receipt"></i>
                        </div>
                        <div className={styles.headerText}>
                            <h2>Order #{modalData.InvoiceId}</h2>
                            <div className={styles.headerMeta}>
                                {getStatusBadge(modalData.orderStatus)}
                                <span className={styles.headerDate}>
                                    <i className="fas fa-calendar-alt"></i>
                                    {Moment(modalData.updateDate).format('DD MMM Y')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <button className={styles.closeBtn} onClick={() => setOpenModal(false)}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                {/* Modal Body */}
                <div className={styles.modalBody}>
                    {/* Products Section */}
                    <div className={styles.section}>
                        <h3 className={styles.sectionTitle}>
                            <i className="fas fa-box"></i> Products
                        </h3>
                        <div className={styles.productsGrid}>
                            {modalData.orderData.map((data, index) => (
                                <a
                                    href={data.slug
                                        ? `https://${modalData.domain}/product/${data.slug}`
                                        : `https://${modalData.domain}/product/${data.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.productCard}
                                    key={index}
                                >
                                    <img src={data.image} alt={data.title || 'product'} className={styles.productImage} />
                                    <div className={styles.productInfo}>
                                        <p className={styles.productName}>{data.title || 'Untitled'}</p>
                                        <p className={styles.productPrice}>৳{data.price}</p>
                                        <div className={styles.productMeta}>
                                            {data.colorName && data.colorName !== 'N/A' && data.colorName !== data.pCode && (
                                                <span className={styles.productColor}>{data.colorName}</span>
                                            )}
                                            {data.Size && data.Size !== 'N/A' && (
                                                <span className={styles.productSize}>{data.Size}</span>
                                            )}
                                            <span className={styles.productQty}>×{data.quantity}</span>
                                        </div>
                                    </div>
                                    <span className={styles.productLink}>
                                        <i className="fas fa-external-link-alt"></i>
                                    </span>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Customer Info & Pricing - Two Column Layout */}
                    <div className={styles.twoColumnLayout}>
                        {/* Customer Information */}
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <i className="fas fa-user"></i> Customer Information
                            </h3>
                            <div className={styles.infoGrid}>
                                <div className={styles.infoItem}>
                                    <span className={styles.infoLabel}><i className="fas fa-user-circle"></i> Name</span>
                                    <span className={styles.infoValue}>{modalData.cName || 'N/A'}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.infoLabel}><i className="fas fa-mobile-alt"></i> Mobile</span>
                                    <span className={styles.infoValue}>
                                        <a href={`tel:${modalData.cMobile}`} className={styles.phoneLink}>
                                            <i className="fas fa-phone"></i> {modalData.cMobile}
                                        </a>
                                    </span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.infoLabel}><i className="fas fa-home"></i> Address</span>
                                    <span className={styles.infoValue}>{modalData.address}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.infoLabel}><i className="fas fa-map-marked-alt"></i> Location</span>
                                    <span className={styles.infoValue}>
                                        {modalData.City[0]?.city || 'Unknown'}, {modalData.City[0]?.regionName || 'Unknown'}
                                    </span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.infoLabel}><i className="fas fa-network-wired"></i> IP Address</span>
                                    <span className={styles.infoValue}>{modalData.City[0]?.query || 'No-IP'}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.infoLabel}><i className="fas fa-wifi"></i> ISP</span>
                                    <span className={styles.infoValue}>{modalData.City[0]?.isp || 'Unknown'}</span>
                                </div>
                            </div>

                            {/* Send Message Section */}
                            {!showMessageBox ? (
                                <button
                                    className={styles.sendMessageBtn}
                                    onClick={() => setShowMessageBox(true)}
                                >
                                    <i className="fas fa-sms"></i> Send Message to Customer
                                </button>
                            ) : (
                                <div className={styles.messageBox}>
                                    <label className={styles.messageLabel}>
                                        <i className="fas fa-comment-dots"></i> Message to Customer
                                    </label>
                                    <textarea
                                        className={styles.messageTextarea}
                                        placeholder="Type your message here..."
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        rows={4}
                                    />
                                    <div className={styles.messageInfo}>
                                        <span className={styles.charCount}>
                                            <i className="fas fa-text-width"></i> {messageLength} characters
                                        </span>
                                        <span className={styles.creditCount}>
                                            <i className="fas fa-credit-card"></i> {smsCreditsNeeded} {smsCreditsNeeded === 1 ? 'credit' : 'credits'} needed
                                        </span>
                                    </div>
                                    <div className={styles.messageActions}>
                                        <button
                                            className={styles.messageCancelBtn}
                                            onClick={() => {
                                                setShowMessageBox(false);
                                                setMessage('');
                                            }}
                                        >
                                            <i className="fas fa-times"></i> Cancel
                                        </button>
                                        <button
                                            className={styles.messageSendBtn}
                                            onClick={handleSendMessage}
                                            disabled={sendingMessage}
                                        >
                                            {sendingMessage ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin"></i> Sending...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-paper-plane"></i> Send
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Pricing Summary */}
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <i className="fas fa-dollar-sign"></i> Pricing Summary
                            </h3>
                            <div className={styles.pricingGrid}>
                                <div className={styles.pricingRow}>
                                    <span><i className="fas fa-tag"></i> Subtotal</span>
                                    <span>৳{modalData.totalPrice}</span>
                                </div>
                                <div className={styles.pricingRow}>
                                    <span><i className="fas fa-truck"></i> Delivery ({modalData.deliveryCharge})</span>
                                    <span>৳{WithDeliveryCharge || 0}</span>
                                </div>
                                {modalData.discount > 0 && (
                                    <div className={styles.pricingRow}>
                                        <span><i className="fas fa-percentage"></i> Discount</span>
                                        <span className={styles.discountAmount}>-৳{modalData.discount}</span>
                                    </div>
                                )}
                                {modalData.advance > 0 && (
                                    <div className={styles.pricingRow}>
                                        <span><i className="fas fa-money-bill-wave"></i> Advance</span>
                                        <span className={styles.discountAmount}>-৳{modalData.advance}</span>
                                    </div>
                                )}
                                <div className={`${styles.pricingRow} ${styles.totalRow}`}>
                                    <span><i className="fas fa-calculator"></i> Total</span>
                                    <span>৳{modalData.totalPrice * 1 + WithDeliveryCharge}</span>
                                </div>
                                <div className={`${styles.pricingRow} ${styles.profitRow}`}>
                                    <span><i className="fas fa-chart-line"></i> Profit</span>
                                    <span>৳{modalData.profit}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Fraud Check Section */}
                    <div className={styles.section}>
                        <h3 className={styles.sectionTitle}>
                            <i className="fas fa-shield-alt"></i> Fraud Analysis
                        </h3>

                        {/* Overall Risk Score */}
                        <div className={`${styles.riskCard} ${styles[`risk${riskData.color}`]}`}>
                            <div className={styles.riskHeader}>
                                <span className={styles.riskLabel}><i className="fas fa-exclamation-triangle"></i> Risk Level</span>
                                <span className={styles.riskLevel}>{riskData.level}</span>
                            </div>
                            <div className={styles.riskProgress}>
                                <div
                                    className={styles.riskProgressBar}
                                    style={{ width: `${riskData.score}%` }}
                                ></div>
                            </div>
                            {riskData.factors.length > 0 && (
                                <div className={styles.riskFactors}>
                                    <i className="fas fa-info-circle"></i> Factors: {riskData.factors.join(', ')}
                                </div>
                            )}
                        </div>

                        {/* Courier Data */}
                        <div className={styles.courierGrid}>
                            {/* Pathao */}
                            <div className={styles.courierCard}>
                                <div className={styles.courierHeader}>
                                    <span className={styles.courierIcon}><FiPackage style={{verticalAlign:'middle'}} /></span>
                                    <h4>Pathao</h4>
                                </div>
                                {!deliveryInfo.is_new ? (
                                    <div className={styles.courierStats}>
                                        {deliveryInfo.success_rate !== null && (
                                            <div className={styles.statItem}>
                                                <span className={styles.statLabel}>Success Rate</span>
                                                <span className={`${styles.statValue} ${styles[`stat${deliveryInfo.success_rate >= 80 ? 'green' : deliveryInfo.success_rate >= 60 ? 'blue' : deliveryInfo.success_rate >= 40 ? 'yellow' : 'red'}`]}`}>
                                                    {deliveryInfo.success_rate}%
                                                </span>
                                            </div>
                                        )}
                                        {deliveryInfo.total_delivery !== null && (
                                            <div className={styles.statItem}>
                                                <span className={styles.statLabel}>Deliveries</span>
                                                <span className={styles.statValue}>
                                                    {deliveryInfo.successful_delivery}/{deliveryInfo.total_delivery}
                                                </span>
                                            </div>
                                        )}
                                        {deliveryInfo.customer_rating && (
                                            <div className={styles.statItem}>
                                                <span className={styles.statLabel}>Rating</span>
                                                <span className={`${styles.statValue} ${styles[`stat${deliveryInfo.customer_rating === 'excellent_customer' ? 'green' : deliveryInfo.customer_rating === 'good_customer' ? 'blue' : deliveryInfo.customer_rating === 'bad_customer' ? 'red' : 'yellow'}`]}`}>
                                                    {deliveryInfo.customer_rating.replace('_', ' ').toUpperCase()}
                                                </span>
                                            </div>
                                        )}
                                        {modalData.FraudPathao?.checkedAt && (
                                            <div className={styles.checkedTime}>
                                                Checked: {Moment(modalData.FraudPathao.checkedAt).fromNow()}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className={styles.noData}>No delivery history</div>
                                )}
                            </div>

                            {/* SteadFast */}
                            <div className={styles.courierCard}>
                                <div className={styles.courierHeader}>
                                    <span className={styles.courierIcon}><FiTruck style={{verticalAlign:'middle'}} /></span>
                                    <h4>SteadFast</h4>
                                </div>
                                {steadfastInfo.error ? (
                                    <div className={styles.noData} style={{color:'#b85a00'}}>
                                        <FiAlertTriangle style={{verticalAlign:'middle'}} /> {steadfastInfo.error}
                                    </div>
                                ) : steadfastInfo.has_data && steadfastInfo.total_orders > 0 ? (
                                    <div className={styles.courierStats}>
                                        <div className={styles.statItem}>
                                            <span className={styles.statLabel}>Success Rate</span>
                                            <span className={`${styles.statValue} ${styles[`stat${steadfastInfo.success_rate >= 80 ? 'green' : steadfastInfo.success_rate >= 60 ? 'blue' : steadfastInfo.success_rate >= 40 ? 'yellow' : 'red'}`]}`}>
                                                {steadfastInfo.success_rate}%
                                            </span>
                                        </div>
                                        <div className={styles.statItem}>
                                            <span className={styles.statLabel}>Delivered</span>
                                            <span className={`${styles.statValue} ${styles.statgreen}`}>
                                                {steadfastInfo.total_delivered}
                                            </span>
                                        </div>
                                        <div className={styles.statItem}>
                                            <span className={styles.statLabel}>Cancelled</span>
                                            <span className={`${styles.statValue} ${styles.statred}`}>
                                                {steadfastInfo.total_cancelled}
                                            </span>
                                        </div>
                                        <div className={styles.statItem}>
                                            <span className={styles.statLabel}>Frauds</span>
                                            <span className={`${styles.statValue} ${steadfastInfo.fraud_count > 0 ? styles.statred : styles.statgreen}`}>
                                                {steadfastInfo.fraud_count > 0 ? <><FiAlertTriangle style={{verticalAlign:'middle'}} /> {steadfastInfo.fraud_count}</> : <><FiCheck style={{verticalAlign:'middle'}} /> 0</>}
                                            </span>
                                        </div>
                                        {steadfastInfo.checkedAt && (
                                            <div className={styles.checkedTime}>
                                                Checked: {Moment(steadfastInfo.checkedAt).fromNow()}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className={styles.noData}>No delivery history</div>
                                )}
                            </div>
                        </div>

                        {/* Additional Fraud Info */}
                        <div className={styles.additionalInfo}>
                            {modalData.Overseas === 1 && (
                                <div className={styles.infoChip}>
                                    <i className="fas fa-plane"></i> From China
                                </div>
                            )}
                            <div className={styles.infoChip}>
                                <i className="fas fa-copy"></i>
                                {DuplicateOrder.length ? `${DuplicateOrder.length} duplicates (72h)` : 'No duplicates (72h)'}
                            </div>
                        </div>
                    </div>

                    {/* Order Details */}
                    <div className={styles.section}>
                        <h3 className={styles.sectionTitle}>
                            <i className="fas fa-info-circle"></i> Order Details
                        </h3>
                        <div className={styles.detailsGrid}>
                            {modalData.TrafficSource && (
                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}><i className="fas fa-share-alt"></i> Traffic Source</span>
                                    <span className={styles.detailValue}>{modalData.TrafficSource}</span>
                                </div>
                            )}
                            {modalData.PaymentType && (
                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}><i className="fas fa-credit-card"></i> Payment Type</span>
                                    <span className={styles.detailValue}>{modalData.PaymentType}</span>
                                </div>
                            )}
                            <div className={styles.detailItem}>
                                <span className={styles.detailLabel}><i className="fas fa-globe"></i> Domain</span>
                                <span className={styles.detailValue}>{modalData.domain}</span>
                            </div>
                            <div className={styles.detailItem}>
                                <span className={styles.detailLabel}><i className="fas fa-user-tag"></i> Assigned To</span>
                                <span className={styles.detailValue}>{modalData.assignedName || 'Not assigned'}</span>
                            </div>
                            <div className={styles.detailItem}>
                                <span className={styles.detailLabel}><i className="fas fa-shopping-cart"></i> Total Items</span>
                                <span className={styles.detailValue}>{modalData.item}</span>
                            </div>
                            {modalData.lateDate && (
                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}><i className="fas fa-clock"></i> Ship Late Date</span>
                                    <span className={styles.detailValue}>
                                        {Moment(modalData.lateDate).format('DD MMM Y, h:mm a')}
                                    </span>
                                </div>
                            )}
                        </div>

                        {/* Product Specifications */}
                        {modalData.orderData && modalData.orderData.length > 0 && (
                            <div className={styles.productDetails}>
                                <h4 className={styles.subSectionTitle}><i className="fas fa-clipboard-list"></i> Product Specifications</h4>
                                {modalData.orderData.map((data, index) => {
                                    const hasColor = data.colorName && data.colorName !== 'N/A' && data.colorName !== data.pCode;
                                    const hasSize = data.Size && data.Size !== 'N/A';
                                    const prodData = modalData.product && modalData.product[index];
                                    const pCode = data.pCode || (prodData && prodData.pCode) || '';
                                    return (
                                        <div key={index} className={styles.productSpec}>
                                            <img src={data.image} alt="" className={styles.specImage} />
                                            <div className={styles.specContent}>
                                                <span className={styles.specName}>{data.title || 'Untitled'}</span>
                                                <div className={styles.specDetails}>
                                                    <span className={styles.specBadge}>×{data.quantity}</span>
                                                    <span className={styles.specPrice}>৳{data.price}</span>
                                                    {hasColor && (
                                                        <span className={styles.specTag}>
                                                            <i className="fas fa-palette"></i> {data.colorName}
                                                        </span>
                                                    )}
                                                    {hasSize && (
                                                        <span className={styles.specTag}>
                                                            <i className="fas fa-ruler"></i> {data.Size}
                                                        </span>
                                                    )}
                                                    {pCode && (
                                                        <span className={styles.specPcode}>
                                                            <i className="fas fa-barcode"></i> {pCode}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Notes */}
                        {(modalData.OrderNote || modalData.privateNote) && (
                            <div className={styles.notesSection}>
                                {modalData.OrderNote && (
                                    <div className={styles.noteCard}>
                                        <h4 className={styles.noteTitle}>
                                            <i className="fas fa-sticky-note"></i> Order Note
                                        </h4>
                                        <p className={styles.noteContent}>{modalData.OrderNote}</p>
                                    </div>
                                )}
                                {modalData.privateNote && (
                                    <div className={`${styles.noteCard} ${styles.privateNote}`}>
                                        <h4 className={styles.noteTitle}>
                                            <i className="fas fa-lock"></i> Private Note
                                        </h4>
                                        <p className={styles.noteContent}>{modalData.privateNote}</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Order Management */}
                    <div className={`${styles.section} ${styles.managementSection}`}>
                        <h3 className={styles.sectionTitle}>
                            <i className="fas fa-cog"></i> Order Management
                        </h3>

                        <div className={styles.formGrid}>
                            {/* Ship Later Date */}
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}>
                                    <i className="fas fa-calendar"></i> Ship Later Date
                                </label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="Select ship date"
                                    className={styles.formInput}
                                    isClearable={true}
                                    todayButton="Today"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    withPortal
                                />
                            </div>

                            {/* Delivery Location */}
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}>
                                    <i className="fas fa-map-marker-alt"></i> Delivery Location *
                                </label>
                                <select
                                    className={styles.formInput}
                                    onChange={(e) => setLocation(e.target.value)}
                                    value={location}
                                >
                                    <option value="">Select Location</option>
                                    <option value="dhaka">Dhaka</option>
                                    <option value="outside">Outside</option>
                                </select>
                            </div>

                            {/* Order Status */}
                            {modalData.orderStatus !== 5 && (
                                <div className={styles.formGroup}>
                                    <label className={styles.formLabel}>
                                        <i className="fas fa-tasks"></i> Order Status *
                                    </label>
                                    <select
                                        className={styles.formInput}
                                        onChange={(e) => setStatus(Number(e.target.value))}
                                        value={status}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="1">New</option>
                                        <option value="2">Call Done</option>
                                        <option value="7">Call Not-Received</option>
                                        <option value="8">Ask-Advance</option>
                                        <option value="9">Ship-Later</option>
                                        <option value="10">Waiting</option>
                                        <option value="11">Overseas</option>
                                        <option value="12">Delivery-Issue</option>
                                        <option value="13">Payment-Received</option>
                                        <option value="3">Courier Done</option>
                                        <option value="4">Print Done</option>
                                        <option value="5">Cancel</option>
                                        <option value="6">Return</option>
                                    </select>
                                </div>
                            )}
                        </div>

                        {/* Return Section */}
                        {status === 6 && (
                            <div className={styles.returnSection}>
                                <div className={styles.returnHeader}>
                                    <i className="fas fa-undo-alt"></i>
                                    <h4>Return Processing</h4>
                                </div>
                                <div className={styles.formGrid}>
                                    <div className={styles.formGroup}>
                                        <label className={styles.formLabel}>
                                            <i className="fas fa-shipping-fast"></i> কুরিয়ার রিটার্ন স্ট্যাটাস
                                        </label>
                                        <select
                                            className={styles.formInput}
                                            onChange={(e) => setCourierReturn(e.target.value)}
                                            value={CourierReturn}
                                        >
                                            <option value="no">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label className={styles.formLabel}>
                                            <i className="fas fa-money-check-alt"></i> রিটার্ন টাকার পরিমাণ (Optional)
                                        </label>
                                        <input
                                            className={styles.formInput}
                                            type="number"
                                            placeholder="টাকা দিয়ে রিটার্ন করেছে? এখানে লিখুন"
                                            value={ReturnAmount}
                                            onChange={(e) => setReturnAmount(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Modal Footer */}
                <div className={styles.modalFooter}>
                    <button className={styles.cancelBtn} onClick={() => setOpenModal(false)}>
                        <i className="fas fa-times"></i> Cancel
                    </button>
                    <button className={styles.updateBtn} onClick={submitH} disabled={loading}>
                        {loading ? (
                            <>
                                <i className="fas fa-spinner fa-spin"></i> Updating...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-check"></i> Update Order
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OrderViewModalRedesigned;
